export default {
	terms: "Terms and Conditions",
	and: "And",
	actions: {
		Submit: "Submit",
		BackToLogin: "Back to Login",
		Register: "Sign up",
		Logout: "Logout",
		Update: "Update",
		Verify: "Verify",
		connect: "Connect",
		Taptochange: "Tap to change"
	},
	rules: {
		isRequired: "Required",
		require: "{0} is required",
		valid: "{0} is not a valid {0}",
		cannotContainBlankStrings: "{0} cannot contain blank strings"
	},
	options: {
		gender: ["Male", "Female"]
	}
};
